import React, { useEffect, useState } from "react";
import "./okr-accordion.scss";
import { AIGeneratedObjectiveAccordion } from "../UnpubishedPlanObjectiveAccordion/ObjectiveAccordion/AIGeneratedObjectiveAccordion";
import { PrimarySmallBoldText } from "../../../../../utils/typographyUtils";

export const OkrAccordion = ({
  objective,
  isPlanPublished,
  callBack,
  businessPlanId,
  closeAllAccordions,
  showActions
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  useEffect(() => {
    if (closeAllAccordions) {
      setIsExpanded(false);
    }
  }, [closeAllAccordions]);
  return (
    <div id="unpublished-plan-okr-accordion">
      <div className="unpublished-plan-okr-accordion">
        <div
          onClick={() => setIsExpanded(!isExpanded)}
          className={`unpublished-plan-okr-accordion-header d-flex align-items-start cursor-pointer justify-content-between p-3 ${isExpanded ? "pb-0" : ""}`}
        >
          <div className="d-flex align-items-top">
            <img
              src="/assets/images/sparkles.svg"
              className="mb-1 me-2"
              height={21}
              width={21}
            />

            <div>
              <PrimarySmallBoldText classNames={"d-block"}>
                Draft Scalability OKR
              </PrimarySmallBoldText>
            </div>
          </div>
          <img
            onClick={(e) => {
              e.stopPropagation();
              setIsExpanded(!isExpanded);
            }}
            className="cursor-pointer"
            src={`/assets/images/${isExpanded ? "up-arrow.svg" : "down-arrow.svg"}`}
          />
        </div>
        <div
          className={`unpublished-plan-okr-accordion-body ${isExpanded ? "open " : ""}`}
        >
          <AIGeneratedObjectiveAccordion
            objective={objective}
            callBack={callBack}
            businessPlanId={businessPlanId}
            isPlanPublished={isPlanPublished}
            showConfirmationButtons={{}}
            closeAllAccordions={closeAllAccordions}
            showActions={showActions}
          />
        </div>
      </div>
    </div>
  );
};
